<template>
  <div class="mine-wrapper">
    <div class="upper-wrapper">
      <div class="village-wrapper">
        <span @click="villageSelect(2)"><img src="../../assets/images/village.png">{{villageName}}<img src="../../assets/images/village-arrow.png"></span>
        <span @click="clickLogout">退出登陆</span>
      </div>
      <div class="information-wrapper">
        <img src="../../assets/images/mine-information-bj.png">
        <div class="information-detail">
          <img :src="headPortrait">
          <div class="information-flex">
            <div>{{nickname}}</div>
            <div>{{usertel}}</div>
          </div>
        </div>
      </div>
      <div class="notice-wrapper" @click="clickNotice">
        <span>通知管理</span>
        <span>></span>
      </div>
      <!-- <div class="logout-wrapper">
        <div>
          <img src="../../assets/images/mine-logout.png">退出登录
        </div>
      </div> -->
    </div>
    <div class="lower-wrapper">
      <div class="navigation" @click="jumpLink">
        <img src="../../assets/images/navigation-index.png">
        <div>首页</div>
      </div>
      <div class="navigation active">
        <img src="../../assets/images/navigation-mine-highlight.png">
        <div>我的</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'mine',
  metaInfo: {
    title: '我的'
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['appid', 'openid', 'headPortrait', 'nickname', 'usertel', 'villageName', 'villageId', 'villageStatus', 'repairId', 'userId', 'roomId', 'roomName', 'lng', 'lat', 'orderTime', 'appointTime', 'setTime', 'warningTime', 'permission', 'wechatRemind'])
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 选择小区
    villageSelect (e) {
      this.$router.push({name: 'Village', query: {index: e}})
    },
    // 跳转
    jumpLink () {
      this.$router.push({name: 'Index'})
    },
    // 退出登陆
    clickLogout () {
      this.changeArgs({
        // openid: '',
        // headPortrait: '',
        // nickname: '',
        // usertel: '',
        // villageName: '请选择小区',
        // villageId: '',
        // villageStatus: 0,
        // repairId: '',
        // userId: '',
        // roomId: '',
        // roomName: '',
        // lng: '',
        // lat: '',
        // orderTime: '',
        // appointTime: '',
        // setTime: '',
        // warningTime: '',
        // permission: '',
        // permissionSign: '',
        // memberId: '',
        // wechatRemind: 0
      })
      // console.log(this.openid)
      this.$router.push({name: 'Account', query: {appid: this.appid}})
    },
    // 通知管理
    clickNotice () {
      this.$router.push({name: 'Notice'})
    }
  }
}
</script>
<style scoped>
.mine-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mine-wrapper .upper-wrapper {
  height: calc(100% - 64px);
  background-color: #f6f6f6;
  padding: 0 15px;
  position: relative;
}
.mine-wrapper .lower-wrapper {
  display: flex;
  font-size: 12px;
  background-color: #ffffff;
  height: 64px;
}
.mine-wrapper .lower-wrapper .navigation {
  flex: 1;
  text-align: center;
  color: #a8a8a8;
}
.mine-wrapper .lower-wrapper .navigation img {
  width: 21px;
  height: 21px;
  margin: 12px 0 2px 0;
}
.mine-wrapper .lower-wrapper .active {
  color: #2d2d2d;
}
.mine-wrapper .village-wrapper {
  text-align: left;
  padding: 15px 0;
  display: flex;
  font-size: 16px;
}
.mine-wrapper .village-wrapper span:first-child {
  flex: 1;
}
.mine-wrapper .village-wrapper span:last-child {
  font-size: 15px;
  color: #333333;
}
.mine-wrapper .village-wrapper img {
  width: 17px;
  height: 17px;
  vertical-align: top;
  padding: 2px 8px 0 0;
}
.mine-wrapper .village-wrapper img:last-child {
  width: 14px;
  height: 14px;
  padding: 4px 0 0 4px;
}
.mine-wrapper .information-wrapper {
  position: relative;
}
.mine-wrapper .information-wrapper img {
  width: 100%;
}
.mine-wrapper .information-wrapper .information-detail {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
.mine-wrapper .information-wrapper .information-detail img {
  width: 50px;
  height: 50px;
  border: solid 3px #ffffff;
  border-radius: 50%;
  margin: 20px 12px 0 19px;
}
.mine-wrapper .information-wrapper .information-detail .information-flex {
  flex: 1;
  color: #ffffff;
  margin-top: 25px;
}
.mine-wrapper .information-wrapper .information-detail .information-flex div:first-child {
  font-size: 17px;
}
.mine-wrapper .information-wrapper .information-detail .information-flex div:last-child {
  font-size: 12px;
  margin-top: 4px;
}
.mine-wrapper .notice-wrapper {
  height: 50px;
  line-height: 50px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 15px;
  display: flex;
  padding: 0 20px;
  font-size: 14px;
}
.mine-wrapper .notice-wrapper span:first-child {
  flex: 1;
}
.mine-wrapper .notice-wrapper span:last-child {
  text-align: right;
  font-size: 17px;
}
.mine-wrapper .logout-wrapper {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 22px;
}
.mine-wrapper .logout-wrapper div {
  height: 50px;
  line-height: 50px;
  background-color: #343434;
  font-size: 14px;
  color: #ffffff;
  border-radius: 6px;
  text-align: center;
  margin: 0 15px;
}
.mine-wrapper .logout-wrapper div img {
  width: 15px;
  height: 15px;
  vertical-align: top;
  padding: 17px 8px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/Mine.vue